import { render, staticRenderFns } from "./通知抵押公告.vue?vue&type=template&id=63e4beff&scoped=true"
import script from "./通知抵押公告.vue?vue&type=script&lang=js"
export * from "./通知抵押公告.vue?vue&type=script&lang=js"
import style0 from "./通知抵押公告.vue?vue&type=style&index=0&id=63e4beff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e4beff",
  null
  
)

export default component.exports